import type { UseAuth } from '../../hooks/useAuth';
import type { DmxConfig } from '../../types';

/**
 * Frontendová politika pravidlo pro původ, poznámku ani poplatek nemá. Backend je při založení
 * přijme jen od ADMIN, tedy od role, která smí zakládat žádosti bez exportu.
 */
export const canSetCounterDetails = (
  customerType: DmxConfig['customerType'],
  hasPermission: UseAuth['hasPermission'],
) => customerType === 'ipr' && hasPermission('ServiceOrders', 'create', null);
